import * as actionTypes from '../actions/actionTypes'

const initialState = {
  business: null
}


const businessReducer = (state = initialState, actions) => {
  switch(actions.type){
    case actionTypes.FETCHING_BUSINESS_SUCCESS:
      return{
        ...state,
        business : actions.business
      }
    default:
      return state
  }
}

export default businessReducer



// WEBPACK FOOTER //
// ./src/store/reducers/businessReducer.js